module.exports = __webpack_public_path__ + "img/dsci0150.b937f1a0.jpg";